import React from "react";
import {Settings} from "../../../models/models";
import {PAYMENT_METHOD_PAGES} from "../../../constants";
import BackButton from "../../common/buttons/BackButton";
import GenericItem from "../../common/items/GenericItem";
import {getFormattedMessage} from "../../../helpers/helpers";
import CardItem from "../../common/items/CardItem";

const PaymentMethodHistoryPage = (props: {settings: Settings,
    handleError: Function, setServerResponse: Function,
    setLoading: Function, setPage: Function,
}) => {
    const {settings, setPage} = props;
    const { paymentHistory } = settings || {};

    const onBackBtnClick = () => {
        setPage(PAYMENT_METHOD_PAGES.SPLASH);
    }

    return (
        <>
            <div className={"col-12"}>
                <div className={`flexColumn`}>
                    <div className={`flexSpaceBetween`} style={{justifyContent:"end"}}>
                        <BackButton onClick={onBackBtnClick}/>
                        <div></div>
                    </div>
                </div>
            </div>

            <div className={'flexColumn'}>
                {
                    paymentHistory?.length === 0 && (
                        <div className={'plan-sub-title'} style={{ fontSize: '1.5em' }}>
                            {i18n.payments.noPaymentHistory}
                        </div>
                    )
                }

                {
                    paymentHistory?.map((item) => {
                        const { id, amount, created, receiptUrl, receiptNumber, description } = item;

                        const receiptNote = receiptNumber
                            ? getFormattedMessage(i18n.payments.receiptNote, receiptNumber, description)
                            : getFormattedMessage(i18n.payments.receiptAltNote, description);
                        const pricePaidNote = getFormattedMessage(i18n.payments.pricePaidNote, amount);
                        const dateNote = getFormattedMessage(i18n.payments.dateNote, created);

                        return (
                            <GenericItem title={receiptNote}
                                         cssClasses={'recent-history-div'}
                                         details={
                                             <div className={'flexSpaceBetween'} style={{ marginBottom: '0.5em' }}>
                                                 <div className={'flexColumn'}>
                                                     <div>{pricePaidNote}</div>
                                                     <div>{dateNote}</div>
                                                     <a href={receiptUrl} target={"_blank"}>{i18n.payments.receiptUrl}</a>
                                                 </div>
                                                 <CardItem paymentMethod={item} styles={{ fontSize: '0.8em' }}/>
                                             </div>
                                         }/>
                        );
                    })
                }

            </div>
        </>
    );
}

export default PaymentMethodHistoryPage;